var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "foundation/icon/1-color/delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,1 C15.6568542,1 17,2.34314575 17,4 L17,4 L17,5 L21,5 C21.5128358,5 21.9355072,5.38604019 21.9932723,5.88337887 L22,6 C22,6.55228475 21.5522847,7 21,7 L21,7 L20,7 L20,20 C20,21.5976809 18.75108,22.9036609 17.1762728,22.9949073 L17,23 L7,23 C5.34314575,23 4,21.6568542 4,20 L4,20 L4,7 L3,7 C2.48716416,7 2.06449284,6.61395981 2.00672773,6.11662113 L2,6 C2,5.44771525 2.44771525,5 3,5 L3,5 L7,5 L7,4 C7,2.40231912 8.24891996,1.09633912 9.82372721,1.00509269 L10,1 Z M18,7 L6,7 L6,20 C6,20.5128358 6.38604019,20.9355072 6.88337887,20.9932723 L7,21 L17,21 C17.5522847,21 18,20.5522847 18,20 L18,20 L18,7 Z M10,10 C10.5522847,10 11,10.4477153 11,11 L11,11 L11,17 C11,17.5522847 10.5522847,18 10,18 C9.44771525,18 9,17.5522847 9,17 L9,17 L9,11 C9,10.4477153 9.44771525,10 10,10 Z M14,10 C14.5522847,10 15,10.4477153 15,11 L15,11 L15,17 C15,17.5522847 14.5522847,18 14,18 C13.4477153,18 13,17.5522847 13,17 L13,17 L13,11 C13,10.4477153 13.4477153,10 14,10 Z M14,3 L10,3 C9.44771525,3 9,3.44771525 9,4 L9,4 L9,5 L15,5 L15,4 C15,3.48716416 14.6139598,3.06449284 14.1166211,3.00672773 L14,3 Z",
    id: "path-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TxT_DLR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "component/form/flow/base/datafield-title-desktop",
    transform: "translate(-578.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "foundation/icon/1-color/delete",
    transform: "translate(576.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-delete",
    mask: "url(#mask-1)",
    fill: "#304FFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c6692b3b588bf00644e88267ff7ca9bd.svg";
export { ForwardRef as ReactComponent };